import { Button } from "@9amhealth/shared";
import type { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconTranscarent } from "src/constants/icons";
import { APP_CONTENT_WIDTH_WITHOUT_PADDING } from "src/constants/layout";
import { Divider } from "src/ui/styled/X";
import Translate from "../Translate/Translate";
import { LoginView } from "./LoginForm";
import { getContinueWithTranscarentTargetUrl } from "src/lib/getContinueWithTranscarentTargetUrl";
import { isHybridApp } from "src/lib/platform";
import { getHeadingProps, useFocusHeading } from "src/lib/useFocusHeading";
import styled from "@emotion/styled";

const HeadingSection = styled.section`
  max-width: ${APP_CONTENT_WIDTH_WITHOUT_PADDING}px;
  margin: 0 auto;
  padding: 0 var(--space-md);
`;

const ContentSection = styled.div`
  padding: 0 var(--space-md);
`;

const LoginOptions: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { headingRef } = useFocusHeading();

  const handleLoginButtonClick = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("view", LoginView.loginForm);
    navigate({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  };

  const handleTranscarentButtonClick = () => {
    const target = getContinueWithTranscarentTargetUrl();

    if (!target) {
      return;
    }

    window.open(target, isHybridApp() ? "_blank" : undefined);
  };

  return (
    <>
      <HeadingSection>
        <h1 className="as-h4-large" ref={headingRef} {...getHeadingProps()}>
          <Translate msg={"login_title"} />
        </h1>
        <div style={{ height: "var(--space-sm)" }} />
        <p className="m0 color-c-80">
          <Translate msg={"login.subtitle"} variables={{ context: "manage" }} />
        </p>
      </HeadingSection>
      <div style={{ height: "var(--space-xl)" }} />
      <ContentSection>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Button theme="sunrise" onPress={() => handleLoginButtonClick()}>
            <Translate msg="signin" variables={{ context: "email" }} />
          </Button>

          <>
            <div style={{ height: "var(--space-sm)" }} />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: "var(--color-gray)"
              }}
            >
              <Divider style={{ flex: 1 }} />
              <span style={{ flex: "0.2", textAlign: "center" }}>
                <Translate msg="or" />
              </span>
              <Divider style={{ flex: 1 }} />
            </div>
            <div style={{ height: "var(--space-sm)" }} />
            <Button
              theme="charcoal"
              hideArrow={true}
              outline={true}
              icon={<IconTranscarent />}
              onPress={() => handleTranscarentButtonClick()}
            >
              <span style={{ fontWeight: "500" }}>
                <Translate
                  msg="login"
                  variables={{ context: "transcarent" }}
                  noWrap
                />
              </span>
            </Button>
          </>
        </div>
      </ContentSection>
    </>
  );
};

export default LoginOptions;
